import { Controller } from '@hotwired/stimulus';
import { get } from '@rails/request.js';

// Connects to data-controller="missive-integration"
export default class extends Controller {
  initialize() {
    const querystringParams = new URLSearchParams(window.location.search);
    this.iframeToken = querystringParams.get('token');
  }

  connect() {
    this.fetchConversations(Missive.state.conversations);
    this.onConversationChange();
  }

  onConversationChange() {
    Missive.on('change:conversations', (ids) => {
      this.fetchConversations(ids);
    });
  }

  fetchConversations(ids) {
    if (!ids) return;

    Missive.fetchConversations(ids).then((conversations) => {
      const emails = Missive.getEmailAddresses(conversations).map((field) => field.address);
      const encodedEmails = encodeURIComponent(emails.join(','));
      get(`/admin/missive_integration/?token=${this.iframeToken}&emails=${encodedEmails}`, {
        responseKind: 'turbo-stream',
      });
    });
  }
}
